import AddressAppResource from './AddressAppResource';
import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from './FileAppResource';
import EmailAppResource from './EmailAppResource';
import PhoneAppResource from './PhoneAppResource';
import UserAppResource from './UserAppResource';
import LuAgentContactTypeAppResource from './LuAgentContactTypeAppResource';
import Engine from "@milestoneslabs/milestones-js-engine";

export const QUALIFICATION_STATUS = Object.freeze({
    NOT_STARTED: 'notStarted',
    PENDING_QUALIFICATION: 'pendingQualification',
    QUALIFIED: 'qualified',
    QUALIFIED_CLOSED: 'qualifiedClosed',
    QUALIFIED_NON_LEAD: 'qualifiedNonLead',
});

class AgentContactAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'agent-contact';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'agents/contacts';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'qualificationStatus',
            'photoFileUuid',
            'photoFile',
            'firstName',
            'lastName',
            'birthdate',
            'company',
            'title',
            'department',
            'description',
            'meta',
            'notesBody',
            'notesUpdatedAt',
            'emails',
            'phones',
            'addresses',
            'agentUserUuid',
            'agent',
            'agentContactTypes',
            'moxiContactId',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            agent: UserAppResource,
            emails: EmailAppResource,
            phones: PhoneAppResource,
            addresses: AddressAppResource,
            photoFile: FileAppResource,
            agentContactTypes: LuAgentContactTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            agent: 'agent_user_uuid',
            photoFile: 'photoFileUuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            photoFileUuid: {
                type: 'string',
            },
            qualificationStatus: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            firstName: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                    tooShort:'is required!'
                },
            },
            lastName: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                    tooShort:'is required!'
                },
            },
            birthdate: {
                datetime: {
                    latest: new Date(),
                },
            },
            company: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            department: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            meta: {},
            notesBody: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            notesUpdatedAt: {
                type: 'string',
                datetime: true,
            },
            agentUserUuid: {
                type: 'string',
                presence: true,
            },
            moxiContactId: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }

    apiPaths() {
        return {
            ...super.apiPaths(),
            'import': Engine.apiUrl('integrations/nylas/importContacts'),
            'customSearch': Engine.apiUrl(this.appResourceApiPrefix()) + '/search/custom',
        };
    }

    async importContacts() {
        const url = this.apiPaths()['import'];
        return await Engine.get(url, {});
    }

}

export default AgentContactAppResource;
